import { forwardRef, useImperativeHandle, useState } from "react"
import styled from "styled-components"
import Spinner from "./Spinner"

const ProductsRow = styled.div`
  align-items: center;
  border-radius: 5px;
  display: flex;
  gap: 15px;
  padding: 5px;

  &:hover {
    box-shadow: 1px 1px 3px 1px silver;
  }
`

export default forwardRef(function EventProduct ({
  eventProduct,
  onUpdate
}, ref) {
  const {
    productName,
    numberOfExpectedUnits,
    numberOfDeliveredUnits
  } = eventProduct

  const hasNumericalValue = (val) => {
    return Boolean(val) || val === 0
  }

  const [isValid, setIsValid] = useState(hasNumericalValue(numberOfDeliveredUnits))

  const deleteOnEmptyString = (val) => {
    if (val === '') return null
    return val
  }

  const handleUpdate = (val) => {
    const newNumberOfDeliveredUnits = deleteOnEmptyString(val)
    
    setIsValid(hasNumericalValue(newNumberOfDeliveredUnits))

    const newEventProduct = {
      ...eventProduct,
      numberOfDeliveredUnits: newNumberOfDeliveredUnits
    }
    onUpdate(newEventProduct)
  }

  useImperativeHandle(ref, () => ({
    isValid: () => {
      return isValid
    }
  }), [isValid])

  return (
    <ProductsRow>
      <div style={{ width: "35%" }}>{productName}</div>
      <div style={{ width: "15%" }}>{numberOfExpectedUnits}</div>
      <Spinner
        value={numberOfDeliveredUnits}
        onChange={val => handleUpdate(val)}
        isInvalid={!isValid}
      />
    </ProductsRow>
  )
})
